import { render, staticRenderFns } from "./CodesReferredModal.vue?vue&type=template&id=3f1c6920"
import script from "./CodesReferredModal.vue?vue&type=script&lang=js"
export * from "./CodesReferredModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports